import { createReducer, on } from '@ngrx/store';

import { IRailEmissionCompany, IRailEmissionReport } from '@ruby/modules/rail-emission/models/rail-emission.interface';
import * as RailEmissionActions from '@ruby/modules/rail-emission/store/actions/rail-emission.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'railEmission';

export interface State {
  loadingCompanies: boolean;
  loading: boolean;
  companies: Array<IRailEmissionCompany>;
  reports: Array<IRailEmissionReport>;
  error?: IError;
}

export const initialState: State = {
  loadingCompanies: true,
  loading: false,
  companies: [],
  reports: [],
  error: undefined
};

export const reducer = createReducer(
  initialState,
  on(RailEmissionActions.loadEmissionFilters, state => ({
    ...state,
    ...initialState
  })),
  on(RailEmissionActions.loadEmissionFiltersSuccess, (state, action) => ({
    ...state,
    loadingCompanies: false,
    companies: action.data
  })),
  on(RailEmissionActions.loadEmissionFiltersFailure, (state, action) => ({
    ...state,
    loadingCompanies: false,
    error: action.error
  })),
  on(RailEmissionActions.loadEmissionReport, state => ({
    ...state,
    loading: true,
    reports: [],
    error: undefined
  })),
  on(RailEmissionActions.loadEmissionReportSuccess, (state, action) => ({
    ...state,
    loading: false,
    reports: action.data
  })),
  on(RailEmissionActions.loadEmissionReportFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(RailEmissionActions.resetState, state => ({
    ...state,
    reports: []
  })),
  on(RailEmissionActions.auditDownload, state => ({
    ...state
  })),
  on(RailEmissionActions.auditDownloadSuccess, (state) => ({
    ...state
  })),
  on(RailEmissionActions.auditDownloadFailure, (state, action) => ({
    ...state,
    error: action.error
  }))
);
